/**
 * Status → rail tone + tone → hex (shared; imported by both the employee SFC and
 * the coach card constants so Storybook/webpack always resolve it).
 *
 * The employee card resolves its rail from the *normalised* status enum
 * (`CARD_STATUSES`), so the snake_case keys below are the source of truth for
 * the employee rail per ER-11336 (verified against all 38 Figma variants):
 *
 *   Status                  Tone    Hex
 *   not_started             grey    #98a2b3
 *   quiz_not_attempted      orange  #f79009
 *   inspection_ready        orange  #f79009
 *   quiz_failed             red     #f04438
 *   inspection_failed       red     #f04438
 *   passed                  green   #17b26a
 *   reset                   purple  #6734d4
 *   not_applicable          blue    #3538cd
 *
 * The legacy human-readable keys are retained for the coach card (which still
 * receives the legacy vocabulary via `buildChecklistInspectionLevels`) and are
 * intentionally NOT updated to the new tones — the coach card has its own rail
 * overrides (`COACH_RAIL_BY_STATUS` in AsACoachCheckpointInspectionCard).
 */
export const RAIL_BY_STATUS = {
  // New vocabulary (employee card after ER-11336 normalisation).
  not_started: "grey",
  quiz_not_attempted: "orange",
  inspection_ready: "orange",
  quiz_failed: "red",
  inspection_failed: "red",
  passed: "green",
  reset: "purple",
  not_applicable: "blue",

  // Legacy vocabulary (coach card / Storybook history).
  "Not started": "grey",
  "Quiz not attempted": "grey",
  "Quiz passed / inspection pending": "orange",
  "Inspection pending": "orange",
  "Awaiting inspection": "grey",
  "Quiz failed": "red",
  "Inspection failed": "red",
  Complete: "green",
  "Inspection passed": "green",
  "Not Applicable": "grey",
  Obsolete: "purple",
};

/** Hex values for status-rail tones (mirrored in scoped CSS rail modifiers). */
export const RAIL_COLOR_BY_TONE = {
  grey: "#98a2b3",
  orange: "#f79009",
  red: "#f04438",
  green: "#17b26a",
  purple: "#6734d4",
  blue: "#3538cd",
};

/**
 * Status tone -> body / action-column background tint (ER-11367, audit table).
 * The employee card tints the body + action column for the error / success /
 * not-applicable statuses only; the remaining statuses stay white:
 *
 *   Tone   Status(es)              Hex
 *   red    quiz_failed, inspection_failed   #fef3f2
 *   green  passed (Complete)                #ecfdf3
 *   blue   not_applicable                   #eef4ff
 */
export const BODY_BACKGROUND_BY_TONE = {
  red: "#fef3f2",
  green: "#ecfdf3",
  blue: "#eef4ff",
};
